<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
      style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</ng-container>
<ngx-spinner></ngx-spinner>
<div class="card card-custom gutter-b" style="margin-top: 30px;">
  <div class="card-header">
    <div class="card-title">
      <h4 class="card-label" style="margin: 15px;font-weight: bold;">
        {{ language == 'en'? "Appointment details": "تفاصيل الحجز" }}
      </h4>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-4">
        <label id="AptDetails">{{ language == 'en'? "Specialty name": "اسم العيادة" }} : </label>
        <label id="AptDetails">{{ language == 'en'? AppointmentDetails?.department : AppointmentDetails?.departmentAr }}   </label>

      </div>
      <div class="col-lg-4">
        <label id="AptDetails">{{ language == 'en'? "Doctor name": "اسم الطبيب" }} :  </label>
        <label id="AptDetails">{{ language == 'en'? AppointmentDetails?.doctor : AppointmentDetails?.doctorAr }}   </label>

      </div>
      <div class="col-lg-4">
        <label id="AptDetails"> {{ language == 'en'? "Date": "التاريخ" }} :  </label>
        <label id="AptDetails"> {{ AppointmentDetails?.appointmentDate | date : 'dd/MM/yyyy h:mm a' :'UTC' }}</label>
      </div>
    </div>
  </div>
</div>
<div class="text-center" style="padding: 15px;">
  <div class="row" style="margin: 30px 0px 20px 0px;">
    <div class="col-lg-12">
      <h3>{{ language == 'en'? "Do you want another service?": "هل تحتاج الي خدمة اخرى؟" }}</h3><br>
    </div>
  </div>
  <div class="text-center" style="margin-bottom: 200px;">
    <div class="col-lg-12">
      <div class="text-center">
        <button style="font-weight: bold;" type="button" class="btn btn-success" routerLink="/portal/appointments/specialties">
          {{ language == 'en'? "Yes": "نعم" }}</button>
        <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="logout()">
          {{ language == 'en'? "No": "لا" }}</button>
        <br>
        <!-- <ng-container *ngIf="isLoading$ | async">
          <div class="spinner-border" role="status" style="margin-top: 30px;">
            <span class="visually-hidden"></span>
          </div>
        </ng-container> -->
      </div>
    </div>
  </div>
</div>